var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{attrs:{"blocks":_vm.blocks,"editable":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var index = ref.index;
var block = ref.block;
return [_c('page-block',_vm._g(_vm._b({staticClass:"p-2",attrs:{"page":_vm.page,"blocks":_vm.blocks,"block":block,"block-index":index}},'page-block',Object.assign({}, _vm.$attrs),false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }